import { render, staticRenderFns } from "./createTechnicalModal.vue?vue&type=template&id=32770376&"
import script from "./createTechnicalModal.vue?vue&type=script&lang=js&"
export * from "./createTechnicalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports